class modalCopyInvoiceCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, $timeout) {
        $scope.modaldata = items1

        httpRequest.get_dictByTypeArr(['ovat_tax_rate']).then((res) => {
            $scope.dictData = res.data.value
        })
        // 分页参数
        $scope.pageOpt2 = {
            totalItems: $scope.modaldata.totalItems, // 组件初始化设置总页数
            currentPage: $scope.modaldata.currentPage, // 设置显示第一页
            maxSize: $scope.modaldata.maxSize, // 每一叶显示记录数
        }
        // 初始化参数
        $scope.modaldata.param = {
            applyDateBegin: '',
            applyDateEnd: '',
            createUser: '',
            custNameCreditCode: '',
            invSort: '',
            invType: $scope.modaldata.invType,
            invoiceCode: '',
            invoiceNumber: '',
            orgId: $scope.modaldata.currentOrgId,
            billCode: '',
            isRed: '0',
            invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
            invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
            taxRate: '',
        }

        $scope.selectedHandle = function selectedHandle() {
            $scope.modaldata.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.modaldata.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.searchInvoicelist()
        }

        // 增加排序功能
        $scope.orderMap = {
            sortKey: 'invoiceDate',
            sortVal: 'desc',
        }
        $scope.modaldata.param.orderMap = { invoiceDate: 'desc' }

        $timeout(() => {
            // 日期设置
            $('#J_datetimeStart').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                const dateText = e.date
                $scope.modaldata.param.applyDateBegin = e.target.value
                $('#J_datetimeEnd').datetimepicker('setStartDate', dateText)
            })
            $('#J_datetimeEnd').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                const dateText = e.date
                $scope.modaldata.param.applyDateEnd = e.target.value
                $('#J_datetimeStart').datetimepicker('setEndDate', dateText)
            })
        })
        $scope.datetimeStartChange = function (e) {
            $scope.modaldata.param.applyDateBegin = e.currentTarget.value
        }
        $scope.datetimeEndChange = function (e) {
            $scope.modaldata.param.applyDateEnd = e.currentTarget.value
        }

        function queryInvoiceList(v) {
            httpRequest.post_qryOvatInvoiceCopyList(v).then((res) => {
                $scope.modaldata.list = res.data.value.list
                // 会写分页参数
                $scope.pageOpt2.totalItems = res.data.value.total
            })
        }
        // 分页
        $scope.pageChanged2 = function () {
            const req = {
                pageNum: $scope.pageOpt2.currentPage,
                pageSize: 5,
                param: $scope.modaldata.param,
            }
            queryInvoiceList(req)
        }
        // 搜索
        $scope.searchInvoicelist = function () {
            const _req = {
                pageNum: 1,
                pageSize: 5,
                param: $scope.modaldata.param,
                orderMap: $scope.modaldata.param.orderMap,
            }
            queryInvoiceList(_req)
        }
        // 选择
        $scope.chooseInvoiceItem = function (item) {
            if (item.tableSource === '0') {
                httpRequest.get_queryOvatInvoiceWait({
                    waitId: item.waitOrInvoiceId,
                }).then((res) => {
                    $uibModalInstance.close(res.data.value)
                })
            } else {
                httpRequest.post_getOvatInvoice(item.waitOrInvoiceId).then((res) => {
                    $uibModalInstance.close(res.data.value)
                })
            }
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

modalCopyInvoiceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', '$timeout']
export default modalCopyInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/modalCopyInvoiceCtrl.js